import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { SITE } from "../data/site";

// Mobile-only sticky CTA bar: slides up (with one bounce) after first scroll.
export const MobileCTA = () => {
  const { scrollY } = useScroll();
  const [show, setShow] = useState(false);
  useMotionValueEvent(scrollY, "change", (y) => setShow(y > 420));

  return (
    <motion.div
      className="fixed inset-x-0 bottom-0 z-50 p-3 md:hidden"
      initial={false}
      animate={{ y: show ? 0 : 110 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    >
      <div className="flex items-center gap-2 rounded-2xl border border-white/10 bg-[#07130C]/90 p-2 shadow-[0_12px_40px_rgba(7,19,12,0.5)] backdrop-blur-xl">
        <Link
          to="/contact"
          data-testid="mobile-cta-book-call"
          className="flex-1 rounded-xl bg-gradient-to-r from-[#1C7543] to-[#D3B74D] px-4 py-3 text-center text-sm font-semibold text-white"
        >
          Book a Free Call
        </Link>
        <a
          href={SITE.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-cta-whatsapp"
          aria-label="Chat on WhatsApp"
          className="flex items-center justify-center rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-white"
        >
          <MessageCircle className="h-5 w-5" />
        </a>
      </div>
    </motion.div>
  );
};
